import { AlertCircle } from 'lucide-react'

import type { PaymentAddrFieldErrorProps } from '@/features/company/types'

export function PaymentAddrFieldError({ message }: PaymentAddrFieldErrorProps) {
    return (
        <div className="mt-1.5 flex items-center gap-2 text-[13px] text-[#b8313b]" role="alert">
            <AlertCircle className="h-4 w-4 shrink-0" aria-hidden />
            <span>{message}</span>
        </div>
    )
}
